<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasPatientCreate" data-bs-backdrop="static" aria-labelledby="offcanvasPatientCreateLabel">
    <div class="offcanvas-header">
      <button class="btn-back" id="btnCloseOffcanvasPatientCreate" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" :aria-label="$t('close')">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" id="offcanvasPatientCreateLabel">{{ $t('patient.create') }}</h5>
    </div>

    <ExamPatientAddFormData @patient-created="onPatientCreated"/>
  </div>
</template>

<style lang="scss" scoped>
#offcanvasPatientCreate {
  width:                              100% !important;
  max-width:                          670px;
  padding:                            0;

  .offcanvas-header {
    padding:                          30px 30px 15px 30px;
  }

  .offcanvas-body {
    display:                          flex;
    flex-direction:                   column;
    flex:                             1;
    min-height:                       0;
    gap:                              20px;
    margin-right:                     30px;
    padding:                          15px 10px 20px 30px;
    overflow-x:                       hidden;
  }
}
</style>

<script>
import ExamPatientAddFormData from '../exam/ExamPatientAddFormData.vue'

export default {
  name: 'PatientCreateOffcanvas',
  components: {
    ExamPatientAddFormData
  },
  methods: {
    show() {
      bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('offcanvasPatientCreate')).show()
    },
    onPatientCreated(patient) {
      document.getElementById('btnCloseOffcanvasPatientCreate').click()
      this.$emit('patient-created', patient)
    },
  }
}
</script>
